import React, { Component } from 'react';
import _ from 'lodash';

import {
  getDivisionDoc,
  getLifterAwardsWeightClassDoc
} from 'util/lifterHelper';

import {
  isLbsMeet,
  isKgMeet,
  getMeetUnits
} from 'util/meetHelper';

import {
  toKg,
  toLbs
} from 'util/conversions';

import DisplayComponent from './DisplayComponent';

class LiftDetails extends Component {

  render() {
    const { meet, currentAttempt, currentLifter, id } = this.props;
    if(!currentAttempt) {
      return null;
    }

    return (
      <DisplayComponent style={{top: 0, left: 0}} id={id}>
        {({ sizeMultiplier }) => {

          const style = {
            fontSize: sizeMultiplier * 38,
            padding: sizeMultiplier * 12
          };

          let recordAttempt = '';
          if(currentAttempt.worldRecord) {
            recordAttempt = (<span>World Record Attempt</span>);
          } else if(currentAttempt.regionalRecord) {
            recordAttempt = (<span>Regional Record Attempt</span>);
          } else if(currentAttempt.stateRecord && currentAttempt.americanRecord) {
            recordAttempt = (<span>State and American Record Attempt</span>);
          } else if(currentAttempt.stateRecord) {
            recordAttempt = (<span>State Record Attempt</span>);
          } else if(currentAttempt.americanRecord) {
            recordAttempt = (<span>American Record Attempt</span>);
          } else if(currentAttempt.provincialRecord && currentAttempt.canadianRecord) {
            recordAttempt = (<span>Canadian and Provincial Record Attempt</span>);
          } else if(currentAttempt.canadianRecord) {
            recordAttempt = (<span>Canadian Record Attempt</span>);
          } else if(currentAttempt.nationalRecord && currentAttempt.provincialRecord) {
            recordAttempt = (<span>Provincial and National Record Attempt</span>);
          } else if(currentAttempt.provincialRecord) {
            recordAttempt = (<span>Provincial Record Attempt</span>);
          } else if(currentAttempt.nationalRecord) {
            recordAttempt = (<span>National Record Attempt</span>);
          }

          const lifterName = _.get(currentLifter, 'name', 'AAAAAAA AAAAAAA');
          const teamName = currentLifter ? _.get(currentLifter, 'team', '') : 'Team Name';
          let liftName =  _.get(currentAttempt, 'liftName', 'Lift');
          if(liftName === 'bench' && meet.federation === 'USSF') {
            liftName = 'press';
          }
          const attemptNumber = _.get(currentAttempt, 'attemptNumber', '0');
          const currentWeight =  _.get(currentAttempt, 'weight', '000');

          return (
            <div style={style} className="lifter-details">
              <div>{lifterName}</div>
              <div>
                {_.capitalize(liftName)}-{attemptNumber}: {currentWeight} {getMeetUnits(meet)}
                <span style={{fontSize: style.fontSize * 0.6}}>
                  { isLbsMeet(meet) &&
                    <span> ({toKg(currentWeight).toFixed(2)} kg)</span>
                  }
                  { isKgMeet(meet) &&
                    <span> ({toLbs(currentWeight).toFixed(2)} lbs)</span>
                  }
                </span>
              </div>
              <div style={{fontSize: style.fontSize * 0.7}} className="record-attempt">
                {recordAttempt}
              </div>
              <div style={{fontSize: style.fontSize * 0.7}} className="team">{teamName}</div>
              <div style={{fontSize: style.fontSize * 0.7}} className="divisions">
                { currentLifter &&
                  _.map(_.get(currentLifter, 'divisions'), (lifterDivision, index) => {
                    const divisionDoc = getDivisionDoc(lifterDivision.divisionId, meet);
                    if(!divisionDoc) {
                      return null;
                    }
                    const divisionName = _.get(divisionDoc, 'name');

                    // don't display weightclass name if there is only one for this division
                    const weightClassDoc = getLifterAwardsWeightClassDoc(meet, currentLifter, lifterDivision);
                    const weightClassName = _.size(divisionDoc.weightClasses) > 1 ? _.get(weightClassDoc, 'name') : '';
                    return (
                      <div key={`${lifterDivision.divisionId}${index}`}>
                        {divisionName} {weightClassName}
                      </div>
                    );
                  })
                }
                { !currentLifter &&
                  <div>
                    Men's Raw Open 120+
                  </div>
                }
              </div>
            </div>
          );
        }}
      </DisplayComponent>
    );
  }
}

export default LiftDetails;
